import { plural } from '@cian/utils';

const OFFERS: [string, string, string] = ['предложение', 'предложения', 'предложений'];

export const getLinkTextForAllOffers = (count: string): string => {
  return `Смотреть все ${count} ${plural(+count, OFFERS)}`;
};
